import panelTemplate from 'templates/measurepanelihm';
import Measureihm from './measurebaseihm';
import MeasureConfiguracionImplihm from '../../impl/ol/js/measureconfiguracionihm';
import measureconfiguracionHTMLihm from '../../templates/measureconfiguracionihm';
import { getValue } from './i18n/language';

/**
 * @classdesc
 * Main constructor of the class. Creates a MeasureConfiguracionihm
 * control to provides measureihm distances
 *
 * @constructor
 * @extends {M.control.Measureihm}
 * @api stable
 */

export default class MeasureConfiguracionihm extends Measureihm {
  constructor() {
    // implementation of this control
    const impl = new MeasureConfiguracionImplihm();

    // calls the super constructor
    super(impl, measureconfiguracionHTMLihm, MeasureConfiguracionihm.NAME);

    // checks if the implementation can create WMC layers
    if (M.utils.isUndefined(MeasureConfiguracionImplihm)) {
      M.Exception(getValue('exception.impl_length'));
    }

    this.checkedContinuo = true;
  }

  /**
   * This function checks if an object is equals
   * to this control
   *
   * @public
   * @function
   * @param {*} obj - Object to compare
   * @returns {boolean} equals - Returns if they are equal or not
   * @api stable
   */
  equals(obj) {
    let equals = false;
    if (obj instanceof MeasureConfiguracionihm) {
      equals = (this.name === obj.name);
    }
    return equals;
  }

  /**
   * function adds the event 'click'
   *
   * @public
   * @function
   * @api
   * @export
   */
  activate() {
    // para que se active el boton
    document.querySelector('.m-measureconfiguracionihm-container').classList.add('activated');
    this.createDrawingTemplate();
    this.activated = true;
  }

  /**
   * Creates drawing options template.
   * @public
   * @function
   * @api
   */
  createDrawingTemplate() {
    this.drawingtoolsihm = M.template.compileSync(panelTemplate, {
      jsonp: true,
      vars: {
        translations: {
          color: getValue('text'),
        },
      },
    });
    if (document.getElementById('drawingtoolsihm') == null) {
      document.getElementsByClassName('m-measurebarihm')[0].appendChild(this.drawingtoolsihm);
      document.querySelector('#actualizar').addEventListener('click', this.actualizarConfig.bind(this));
      document.getElementById('drawingtoolsihm').classList.add('measureconfiguracionihmshow');
    } else {
      document.getElementById('drawingtoolsihm').classList.remove('measureconfiguracionihmhide');
      document.getElementById('drawingtoolsihm').classList.add('measureconfiguracionihmshow');
    }
  }

  deactivate() {
    if (document.getElementById('drawingtoolsihm') !== null) {
      document.getElementById('drawingtoolsihm').classList.add('measureconfiguracionihmhide');
      document.getElementById('drawingtoolsihm').classList.remove('measureconfiguracionihmshow');
      document.querySelector('.m-measureconfiguracionihm-container').classList.remove('activated');
    }
  }

  /**
   * This function controls the configuration options
   *
   * @public
   * @function
   * @api stable
   */
  actualizarConfig() {
    const checked = [];

    if (document.getElementById('rumbo').checked) {
      checked.push('rumbo');
    }
    if (document.getElementById('segmento').checked) {
      checked.push('segmento');
    }
    if (document.getElementById('continuo').checked) {
      checked.push('continuo');
      if (!this.checkedContinuo) {
        this.checkedContinuo = true;
        this.getImpl().setEventCheck(true);
      }
    }
    if (document.getElementById('sismedidas').checked) {
      checked.push('sismedidas');
    }

    if (!checked.includes('continuo')) {
      this.checkedContinuo = false;
      this.getImpl().setEventCheck(false);
    }
    this.getImpl().setChecked(checked);

    const plugins = this.map_.getPlugins().filter((plugin) => {
      return plugin.name === 'measurebarihm';
    });
    const clear = plugins[0].getControls().filter((control) => {
      return (control.name === 'measurebarihm');
    })[0];
    clear.getImpl().onClick();
  }
}
/**
 * Name for this controls
 * @const
 * @type {string}
 * @public
 * @api stable
 */
MeasureConfiguracionihm.NAME = 'measureconfiguracionihm';

/**
 * Template for this controls
 * @const
 * @type {string}
 * @public
 * @api stable
 */
MeasureConfiguracionihm.TEMPLATE = 'measureconfiguracionihm.html';

/**
 * Help message
 * @const
 * @type {string}
 * @public
 * @api stable
 */
export const HELP_KEEP_MESSAGE = getValue('text.keep_drawing');
